import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import EmbeddedModal from 'components/modal/EmbeddedModal'
import ModalButton from 'components/modal/ModalButton'

const ErrorScreen = props => {
  return (
    <Div
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <EmbeddedModal
        actions={[
          <ModalButton
            key="close"
            testId="close"
            title="Close"
            onClick={props.onActionClick}
          />
        ]}
      >
        Something went wrong. Please close this screen and try again.
      </EmbeddedModal>
    </Div>
  )
}

ErrorScreen.propTypes = {
  onActionClick: PropTypes.func
}

ErrorScreen.defaultProps = {
  onActionClick: () => {}
}

export default ErrorScreen



// WEBPACK FOOTER //
// ./src/components/app/ErrorScreen.js